import React from 'react';
import MainLayout from '../../layouts/general-layout';
import { useTranslation } from 'react-i18next';

export default function LearningPage() {
  const { t } = useTranslation();

  return (
    <div style={{ 
      padding: '40px 20px', 
      textAlign: 'center', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: '60vh'
    }}>
      <h1 style={{ fontSize: '32px', marginBottom: '16px', color: '#1C252E' }}>
        {t('learningPageTitle', 'לימוד')}
      </h1>
      <p style={{ fontSize: '18px', color: '#637381', maxWidth: '400px' }}>
        {t('learningPageSubtitle', 'עמוד זה נמצא בבנייה. בקרוב תוכלו ללמוד כאן נושאים חדשים!')}
      </p>
      
      <div style={{ 
        marginTop: '32px', 
        width: '120px', 
        height: '120px', 
        backgroundColor: '#F2FFCF', 
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '48px'
      }}>
        📚
      </div>
    </div>
  );
}
